import {type DataTypeProvider} from '@devexpress/dx-react-grid';

export function OptixTableDataTypeNumberFormatter({
  value,
}: DataTypeProvider.ValueFormatterProps): JSX.Element {
  return value;
}
